module.exports = __webpack_public_path__ + "components/flag/static/square/hn-a19cb41494cc8409d09f2447f8dd7e73.svg";